import type { Event } from '@/types';

import CalendarDay from './calendarDay';
import {
  getCalendarOfEvents,
  getDaysOfTheWeek,
  getStartDayByLanguage,
} from './helpers';

interface EventCalendarProps {
  events: Array<Event>;
  language: string | null;
}

const EventCalendar = ({ events, language }: EventCalendarProps) => {
  const startDay = getStartDayByLanguage(language);
  const calendarDays = getCalendarOfEvents(events, startDay);
  const days = getDaysOfTheWeek(startDay);

  if (!calendarDays.length) {
    return <div className="text-center">No events scheduled.</div>;
  }

  return (
    <div className="event-calendar">
      {days.map((day) => (
        <div className="event-calendar-headings" key={day}>
          {day}
        </div>
      ))}
      {calendarDays.map((calendarDay) => (
        <CalendarDay
          key={calendarDay.date.valueOf()}
          calendarDay={calendarDay}
        />
      ))}
    </div>
  );
};

export default EventCalendar;
